
import React from "react";

import { speech } from "../../services/speech";
import PostList from "./PostList";

const SpeechPage = () => {
    return <PostList fetchPostsFn={speech} sectionTitle="Latest Speeches" />;
};

export default SpeechPage;
